// When to offer a signed-in player a passkey. The pattern follows how Microsoft
// Entra nudges people off weaker sign-in: ask right after they have signed in
// (they have just proved who they are), only if they do not already have one and
// their device can use one, make it dismissible, and never nag. Nothing is ever
// blocked: the email code stays as a fallback.
//
// The rules live here as a pure function so they are easy to test and to tune.

/** After a dismissal, stay quiet for this long. */
export const PASSKEY_OFFER_COOLDOWN_MS = 30 * 24 * 60 * 60 * 1000

export interface PasskeyOfferInput {
  /** The backend has passkeys switched on. */
  enabledByServer: boolean
  /** This browser and device can use passkeys. */
  supportedByDevice: boolean
  /** The player's passkeys have been loaded (never offer on a guess). */
  loaded: boolean
  hasPasskeys: boolean
  /** When the player last chose "Not now", or null if never. */
  lastDismissedAt: number | null
  now: number
}

export const shouldOfferPasskey = ({
  enabledByServer,
  supportedByDevice,
  loaded,
  hasPasskeys,
  lastDismissedAt,
  now,
}: PasskeyOfferInput): boolean => {
  if (!enabledByServer || !supportedByDevice || !loaded || hasPasskeys) return false
  if (lastDismissedAt === null) return true
  // A clock set back must not silence the offer forever.
  if (lastDismissedAt > now) return true
  return now - lastDismissedAt >= PASSKEY_OFFER_COOLDOWN_MS
}
